var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 282,
    viewBox: "0 0 658 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.205 -467.814C483.809 -420.457 584.072 -459.034 611.959 -466.691C697.132 -490.072 820.337 -530.929 884.912 -439.119C921.578 -386.991 918.974 -307.894 881.006 -255.142C831.618 -186.52 672.576 -106.953 701.233 -37.832C717.235 0.756042 762.559 -11.4869 788.217 12.108C861.876 79.846 731.037 170.693 687.348 201.352C606.281 258.239 490.451 304.777 393.906 270.069C362.51 258.782 334.949 226.686 338.687 191.444C341.902 161.131 356.507 139.461 338.817 111.15C322.38 84.846 286.869 73.484 258.929 72.565C186.158 70.174 99.9241 130.818 33.5941 86.875C18.0941 76.607 5.06711 60.725 1.21111 41.645C-2.89589 21.325 3.87111 -0.106995 15.0711 -17.06C59.7411 -84.672 131.726 -124.616 196.08 -167.12C226.71 -187.347 260.452 -217.294 255.622 -255.536C250.606 -295.256 208.51 -313.827 174.077 -329.521C-46.6599 -430.14 453.65 -707.503 466.134 -489.562C466.554 -482.264 465.931 -474.727 468.205 -467.814Z",
    fill: "#FFE8F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 658,
    height: 282,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.608be04700d3d600629980829421bc3b.svg";
export { ForwardRef as ReactComponent };